import { render, staticRenderFns } from "./galleryView.vue?vue&type=template&id=8c5666cc&scoped=true"
import script from "./galleryView.vue?vue&type=script&lang=js"
export * from "./galleryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5666cc",
  null
  
)

export default component.exports